import { hasCoursesQueryOptions } from "@/queries/courses/hasCoursesQuery";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "@vixi/localization";
import { RouteOptionsById, router, RouterIds } from "@vixi/router";
import { ButtonLink, Img, PageMainContent, useGoBack } from "@vixi/ui";

// Assets
import qrCode from "@assets/qr-code.png";
import vixi from "@assets/vixi-paper-clip.png";

const routeId = "/_app/dashboard/" satisfies RouterIds;
const Route = router.routesById[routeId];

export const DashboardIndexPageOptions: RouteOptionsById<typeof routeId> = {
  component: RouteComponent,
};

function RouteComponent() {
  useGoBack(null);
  const { t, tFile, byLocale } = useTranslation();

  const { data: hasCourses, isSuccess: hasCoursesSuccess } = useQuery(hasCoursesQueryOptions());

  return (
    <PageMainContent psY="medium">
      {/* Header */}
      <div className="bg-paper flex items-center justify-between rounded px-6.25 py-4.75">
        {/* Welcome Message */}
        <div>
          <p className="fs-20 text-foreground-secondary">{t("WelcomeTo")}</p>
          <h2 className="fs-32">
            <span className="text-primary fs-inherit fw-inherit inline">
              {t("Dashboard.Vixi")}{" "}
            </span>

            {t("Dashboard.CourseMaker")}
          </h2>
        </div>

        {/* Vixi Image */}
        <Img contain className="h-32.25 w-50.25" src={vixi} />

        {/* Qr Code */}
        <div className="flex items-center">
          <p className="max-w-30.5 text-end leading-none">{t("Dashboard.ScanCode")}</p>

          <Img src={qrCode} alt="QR Code" className="mx-2.5 h-22.25 w-22.25" />
        </div>
      </div>

      {/* In Progress Courses Section - Now shown as fixed card in all pages via InProgressCoursesSection component */}

      {/* No courses yet */}
      {hasCoursesSuccess && !hasCourses && (
        <div className="relative m-auto">
          <Img src={tFile("/images/", "bubble-no-courses.png")} className="w-100.75" />
          <ButtonLink
            to="/create"
            variant="contained"
            color="primary"
            size="small"
            className="ar:bottom-30 absolute start-0 bottom-10 w-58.25"
          >
            {t("Action.CreateCourse")}
          </ButtonLink>
        </div>
      )}
    </PageMainContent>
  );
}
